class OkazoProductServiceLink extends HTMLElement {
  connectedCallback() {
    if (this.connection) return;
    const disclosure = document.getElementById(this.dataset.target);
    const link = this.querySelector("a");
    if (!disclosure || !link) return;
    this.connection = new AbortController();
    link.addEventListener(
      "click",
      (event) => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        disclosure.open = true;
        const summary = disclosure.querySelector("summary");
        summary?.focus({ preventScroll: true });
        (summary || disclosure).scrollIntoView({
          block: "start",
          behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth",
        });
      },
      { signal: this.connection.signal },
    );
  }

  disconnectedCallback() {
    this.connection?.abort();
    this.connection = null;
  }
}

if (!customElements.get("okazo-product-service-link")) {
  customElements.define("okazo-product-service-link", OkazoProductServiceLink);
}

class OkazoProductMedia extends HTMLElement {
  connectedCallback() {
    if (this.connection) return;
    this.connection = new AbortController();
    const { signal } = this.connection;
    this.addEventListener(
      "click",
      (event) => {
        const button = event.target.closest("[data-media-src]");
        const image = this.querySelector(".okz-pdp__main-image");
        if (!button || !image) return;
        image.removeAttribute("srcset");
        image.src = button.dataset.mediaSrc;
        image.alt = button.dataset.mediaAlt;
        image.width = Number(button.dataset.mediaWidth);
        image.height = Number(button.dataset.mediaHeight);
        image.closest("[data-okz-image-fallback]")?.classList.remove("is-image-broken");
        this.querySelectorAll("[data-media-src]").forEach((thumb) => {
          thumb.setAttribute("aria-pressed", String(thumb === button));
          thumb.classList.toggle("is-active", thumb === button);
        });
      },
      { signal },
    );
  }

  disconnectedCallback() {
    this.connection?.abort();
    this.connection = null;
  }
}

if (!customElements.get("okazo-product-media")) customElements.define("okazo-product-media", OkazoProductMedia);

class OkazoMobilePurchaseBar extends HTMLElement {
  connectedCallback() {
    if (this.ctaObserver || !("IntersectionObserver" in window)) return;
    const sectionId = this.id.replace("OkazoMobilePurchase-", "");
    const mainCta = document.getElementById(`card-submit-button-${sectionId}`);
    const footer = document.querySelector(".okz-shell-footer");
    this.footerVisible = false;
    this.mainCtaPassed = false;
    this.footerObserver = new IntersectionObserver(
      (entries) => {
        this.footerVisible = entries.some((entry) => entry.isIntersecting);
        this.updateVisibility();
      },
      { threshold: 0.02 },
    );
    this.ctaObserver = new IntersectionObserver(
      (entries) => {
        const entry = entries.find((candidate) => candidate.target === mainCta);
        if (!entry) return;
        this.mainCtaPassed = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
        this.updateVisibility();
      },
      { threshold: 0 },
    );
    // A jump can skip both sides of the viewport without crossing an observer threshold.
    this.onScroll = () => {
      if (this.scrollFrame) return;
      this.scrollFrame = window.requestAnimationFrame(() => {
        this.scrollFrame = null;
        if (mainCta) this.mainCtaPassed = mainCta.getBoundingClientRect().bottom <= 0;
        this.updateVisibility();
      });
    };
    this.connection = new AbortController();
    window.addEventListener("scroll", this.onScroll, { passive: true, signal: this.connection.signal });
    if (footer) this.footerObserver.observe(footer);
    if (mainCta) this.ctaObserver.observe(mainCta);
    this.updateVisibility();
  }

  disconnectedCallback() {
    this.connection?.abort();
    this.connection = null;
    window.cancelAnimationFrame(this.scrollFrame);
    this.scrollFrame = null;
    this.footerObserver?.disconnect();
    this.ctaObserver?.disconnect();
    this.footerObserver = null;
    this.ctaObserver = null;
  }

  updateVisibility() {
    this.classList.toggle("is-hidden", this.footerVisible || !this.mainCtaPassed);
  }
}

if (!customElements.get("okazo-mobile-purchase")) {
  customElements.define("okazo-mobile-purchase", OkazoMobilePurchaseBar);
}
